import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Label from 'components/connectedForm/Label';
import Value from 'components/connectedForm/Value';
import styled from 'styled-components';

const OverviewFieldContainer = styled.div`
  flex-grow: 1;
  flex-basis: auto;
  width: auto;
  max-width: none;
  text-align: left;
  padding-left: 16px;
  padding-bottom: ${(props) => (props.isList ? '0px' : '12px')};
`;

export default class OverviewField extends Component {
  focus() {
    this.node.focus();
  }

  render() {
    const {
      alignLabel,
      bold,
      id,
      label,
      includeLabel,
      flexBox,
      labelCols,
      labelAddon,
      inputCols,
      hideField,
      view,
      uppercaseLabel,
      labelDisplay,
      verticalAlign,
    } = this.props;

    const labelProps = {
      bold,
      flexBox,
      id,
      includeLabel,
      label,
      labelAddon,
      view,
      alignLabel,
      uppercaseLabel,
      verticalAlign,
    };

    if (this.props.inGrid) return <Value {...this.props} />;
    return (
      <OverviewFieldContainer isList={this.props.list}>
        {label ? (
          <Label {...labelProps} display={labelDisplay} cols={labelCols} view={view} bold={bold}>
            {label}
          </Label>
        ) : null}
        <Value {...this.props} />
      </OverviewFieldContainer>
    );
  }
}

OverviewField.propTypes = {
  includeLabel: PropTypes.bool,
  flexBox: PropTypes.bool,
  labelCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  iconSuffix: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  alignLabel: PropTypes.string,
  uppercaseLabel: PropTypes.string,
  view: PropTypes.bool,
  fontSize: PropTypes.string,
  align: PropTypes.string,
  labelDisplay: PropTypes.string,
  verticalAlign: PropTypes.string,
  list: PropTypes.bool,
};
OverviewField.defaultProps = {
  onChange: () => {},
  includeLabel: true,
  inputPrefix: null,
  flexBox: true,
  labelCols: 1 / 4,
  inputCols: 3 / 4,
  value: '',
  label: '',
  id: '',
  iconSuffix: false,
  bold: false,
  view: true,
  alignLabel: 'left',
  uppercaseLabel: 'none',
  fontSize: '14px',
  align: 'left',
  labelDisplay: 'block',
  verticalAlign: 'top',
};
